export default __webpack_public_path__ + "static/logo_footer_new-57e921af754c59b8caca831c9d377e0a.jpg";